<p>The bidding system is designed for students to actually place bids by <strong>sections</strong> of a course. So, if a course has two sections you bid on the section you wish to be in.</p>
<p>Losing Bids (Current Bids) from the first bid round are automatically carried over to the next bidding round. You may choose to do the following with your losing bids from round 1:</p>
<ol>
    <li>Keep the points on the same section(s);</li>
    <li>Increase (IF you have more points) or decrease the number of points on a section;</li>
    <li>Or, remove the points altogether and reallocate them to another section;</li>
</ol>
<p>You may perform the following activities with Current Bids:</p>
<div class="table-responsive">
    <table class="table table-hover">
        <thead class="thead-">
            <tr>                
                <th> Activity </th>
                <th> Description </th>
            </tr>
        </thead>
        <tbody>
            <tr>                
                <td> Remove </td>
                <td> Delete a current bid to receive the bid points back. </td>
            </tr>
            <tr>                
                <td> Update </td>
                <td> Increase or decrease the number of points for your bid. You must have enough remaining points to do this. </td>
            </tr>            
        </tbody>
    </table>
</div>
